import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { useLocalization } from '~/composables/_next/useLocalization';
export function useSkeepers() {
  var loaded = useState('skeeper-loaded', function () {
    return false;
  });
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var scriptForWidgetReview = {
    fr: 'https://widgets.rr.skeepers.io/product/4ee763a5-657d-7844-d52d-da2a59c5b3ac/91612a8e-87e1-4df9-9db8-8cf22076aaf0.js',
    it: 'https://widgets.rr.skeepers.io/product/a02cd4b5-4a33-b9e4-c193-965b64655ada/edafbe46-ba47-48db-9eee-d8b5d1bd4429.js',
    en: 'https://widgets.rr.skeepers.io/product/2b7c399a-6ca3-74c4-61e6-4022446499b9/9f89ea29-bca9-466b-82f1-f8cb99aecc9e.js',
    de: 'https://widgets.rr.skeepers.io/product/fa551603-c628-9644-197e-f89c985f637e/2f9712a7-f9a7-45fd-a451-474152b5e242.js',
    es: 'https://widgets.rr.skeepers.io/product/f7e6a72c-7348-fda4-0512-9ff51d90a0d5/e5476a42-4f82-4160-af7e-ebdff8ad6a50.js'
  };

  /**
   * Loads a skeepers script.
   *
   */
  function loadSkeepers() {
    if (process.server) throw new Error('Skeeper is only available client side');
    if (loaded.value) return true;
    return new Promise(function (resolve, reject) {
      if (document.getElementById('SkeepersProductWidgetScript')) {
        resolve(true);
        return;
      }
      var script = document.createElement('script');
      script.id = 'SkeepersProductWidgetScript';
      script.src = scriptForWidgetReview[locale];
      script.type = 'text/javascript';
      script.defer = true;
      script.setAttribute('data-prevent-default-loading', true);
      script.onload = function () {
        resolve(true);
      };
      script.onerror = function (error) {
        console.error('Skeeper script could not be loaded', error);
        reject(error);
      };
      document.head.appendChild(script);
    });
  }

  /**
   * Generates a Skeeper widget.
   *
   */
  function generateWidget() {
    return _generateWidget.apply(this, arguments);
  }
  function _generateWidget() {
    _generateWidget = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var skeepers;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            skeepers = window.SkeepersProductWidget;
            _context.next = 4;
            return skeepers === null || skeepers === void 0 ? void 0 : skeepers.generate();
          case 4:
            return _context.abrupt("return", true);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", false);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _generateWidget.apply(this, arguments);
  }
  return {
    loadSkeepers: loadSkeepers,
    generateWidget: generateWidget
  };
}